import * as React from 'react';
import * as PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import styles from './ErrorDialogStyles';
import * as _ from 'lodash';
import {Omit} from "utility-types";
let instance;

export interface ErrorDialogProps {
  open: boolean,
  setOpen(open: boolean): void,
  errorTitle?: string,
  errorMessage?: React.ReactNode,
  reportButtonLabel?: string,
  retryButtonLabel?: string,
  onReportButtonClick?(): void,
  onRetryButtonClick?(): void,
}

export default class ErrorDialog extends React.PureComponent<ErrorDialogProps, ErrorDialogProps> {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    errorTitle: PropTypes.string,
    errorMessage: PropTypes.node,
    reportButtonLabel: PropTypes.string,
    retryButtonLabel: PropTypes.string,
    onReportButtonClick: PropTypes.func,
    onRetryButtonClick: PropTypes.func,
  };

  static defaultProps: Partial<ErrorDialogProps> = {
    open: false,
    retryButtonLabel: 'retry'
  };

  constructor(props) {
    super(props);
    if (!instance) {
      instance = this;
    }
    this.state = {...props};
    this.onRetryButtonClick = this.onRetryButtonClick.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    this.onReportButtonClick = this.onReportButtonClick.bind(this);
  }

  onRetryButtonClick() {
    const { onRetryButtonClick } = this.state;
    const { setOpen } = this.props;
    if (onRetryButtonClick) {
      onRetryButtonClick();
      setOpen(false);
    }
  }

  onCloseButtonClick() {
    const { setOpen } = this.props;
    setOpen(false);
  }

  onReportButtonClick() {
    const { onReportButtonClick } = this.state;
    if (onReportButtonClick) {
      onReportButtonClick();
    }
  }

  static error(props: Omit<ErrorDialogProps, 'open' | 'setOpen'>) {
    const {setOpen} = instance.props;
    instance.setState({..._.mapValues(instance.state, () => undefined), ...ErrorDialog.defaultProps, ...props});
    setOpen(true);
  }

  render() {
    const { open } = this.props;
    const { errorTitle, errorMessage, reportButtonLabel, retryButtonLabel } = this.state;
    return (
      <Dialog
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        open={open}
      >
        <div style={styles.dialogHeader}>
          <FontIcon style={styles.infoBoxIcon} color={'white'} className="material-icons">error</FontIcon>
          {errorTitle}
          <span style={{flexGrow: 1}}/>
          <IconButton
            onClick={this.onCloseButtonClick}
            iconStyle={styles.closeIcon}
          >
            <FontIcon className="material-icons">close</FontIcon>
          </IconButton>
        </div>
        <div style={styles.errorMessageContainer}>
          {errorMessage}
        </div>
        <div
          style={styles.dialogFooter}>
          {
            reportButtonLabel ?
              <FlatButton
                style={styles.reportErrorButton}
                labelStyle={styles.reportErrorButtonLabel}
                label={reportButtonLabel}
                onClick={this.onReportButtonClick}
              /> : <div/>
          }
          {
            retryButtonLabel ? <FlatButton
              primary
              style={styles.retryButton}
              label={retryButtonLabel}
              onClick={this.onRetryButtonClick}
            /> : null
          }
        </div>
      </Dialog>
    );
  }
}
